import React from "react"
import {
  Switch
} from "@material-ui/core";


function CustomSwitch({onChange, checked, hook=false}) {
    const [checkedInternal, setCheckedInternal] = React.useState(false)

    React.useEffect(() => {
        setCheckedInternal(checked)
    }, [checked])

    const handleChange = (event) => {
        let flag = event.target.checked
        setCheckedInternal(flag)
        if(Boolean(hook)){
            hook(flag)
        }
    }

    return (
        <Switch
            checked={checkedInternal}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
        />
    );
}

export default CustomSwitch

